"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinutePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const picker_styles_1 = require("./picker-styles");
const PickerStepControls_1 = require("./PickerStepControls");
const translate_1 = require("../../translate");
const NumberInput = (0, styled_1.default)(picker_styles_1.FirstRowInput) `
  width: 80px;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    display: none;
  }

  -moz-appearance: textfield;
`;
const MINUTE_STEP = 5;
const MinutePicker = ({ value, onChange, step = MINUTE_STEP, }) => {
    const t = (0, translate_1.useTranslations)();
    const handleMinusClick = () => {
        const newValue = value - step;
        onChange(Math.ceil(newValue / step) * step);
    };
    const handlePlusClick = () => {
        const newValue = value + step;
        onChange(Math.floor(newValue / step) * step);
    };
    return ((0, jsx_runtime_1.jsxs)(PickerStepControls_1.PickerStepButtons, { onMinusClick: handleMinusClick, onPlusClick: handlePlusClick, minusDisabled: value <= 0, children: [(0, jsx_runtime_1.jsx)(NumberInput, { type: "number", min: 0, value: value, onChange: (e) => onChange(parseInt(e.target.value)) }), (0, jsx_runtime_1.jsx)(picker_styles_1.SecondRowText, { children: t.common.minutes() })] }));
};
exports.MinutePicker = MinutePicker;
